import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

class TailgateListPage extends Component {
  render() {
    const bread = [{ text: "Liste des tailgates" }];

    return (
      <Fragment>
        <Helmet>{title("Liste des tailgates")}</Helmet>

        <div className="tailgate-list-page main-content">
          <Header title="Tailgates" bread={bread} />
          <List type="tailgates" />
        </div>
      </Fragment>
    );
  }
}

export default TailgateListPage;
